import type { TabLocationMarker } from "@/map/location-markers/types";
import { useLocationTables } from "@/reducer/LocationTablesState";
import { usePlots } from "@/reducer/PlotsState";
import { useTephigrams } from "@/reducer/TephigramState";
import { useWeatherTables } from "@/reducer/WeatherTablesState";
import { useMemo } from "react";
import { buildTabLocationMarkers } from "./locationMarkers";

export function useTabLocationMarkers(tabId: number): TabLocationMarker[] {
  const plots = usePlots(tabId);
  const weatherTables = useWeatherTables(tabId);
  const locationTables = useLocationTables(tabId);
  const tephigrams = useTephigrams(tabId);

  return useMemo(
    () =>
      buildTabLocationMarkers({
        plots,
        weatherTables,
        locationTables,
        tephigrams,
      }),
    [plots, weatherTables, locationTables, tephigrams],
  );
}
